import Parameter from "views/logic/parameters/Parameter";
import ParameterBinding from "views/logic/parameters/ParameterBinding";
import OptionSource from "enterprise/parameters/components/option/OptionSource";
const _OptionParameter = class _OptionParameter extends Parameter {
  constructor(name, title, description, dataType, defaultValue, optional, source, binding) {
    super(_OptionParameter.type, name, title, description, dataType, defaultValue, optional, binding);
    this._source = source;
  }
  static create(name, title, description, dataType, defaultValue, optional, source, binding) {
    return new _OptionParameter(name, title, description, dataType, defaultValue, optional, source, binding);
  }
  get source() {
    return this._source;
  }
  toBuilder() {
    const { type, name, title, description, dataType, defaultValue, optional, binding } = this._value;
    return new Builder({
      type,
      name,
      title,
      description,
      dataType,
      defaultValue,
      optional,
      binding,
      source: this._source
    });
  }
  toJSON() {
    const { type, name, title, description, dataType, defaultValue, optional, binding } = this._value;
    return {
      type,
      name,
      title,
      description,
      data_type: dataType,
      default_value: defaultValue,
      optional,
      binding: binding ? binding.toJSON() : void 0,
      source: this._source ? this._source.toJSON() : void 0
    };
  }
  static fromJSON(value) {
    const { name, title, description, data_type, default_value, optional, binding, source } = value;
    return new _OptionParameter(
      name,
      title,
      description,
      data_type,
      default_value,
      optional,
      OptionSource.fromJSON(source),
      ParameterBinding.fromJSON(binding)
    );
  }
  static builder() {
    return new Builder().type(_OptionParameter.type).optional(false).dataType("any").binding(ParameterBinding.empty());
  }
};
_OptionParameter.type = "option-parameter-v1";
let OptionParameter = _OptionParameter;
export {
  OptionParameter as default
};
class Builder {
  constructor(value = {}) {
    this.value = value;
    Object.freeze(this.value);
    Object.seal(this.value);
    Object.freeze(this);
    Object.seal(this);
  }
  type(value) {
    return new Builder({ ...this.value, type: value });
  }
  name(value) {
    return new Builder({ ...this.value, name: value });
  }
  title(value) {
    return new Builder({ ...this.value, title: value });
  }
  description(value) {
    return new Builder({ ...this.value, description: value });
  }
  dataType(value) {
    return new Builder({ ...this.value, dataType: value });
  }
  defaultValue(value) {
    return new Builder({ ...this.value, defaultValue: value });
  }
  optional(value) {
    return new Builder({ ...this.value, optional: value });
  }
  binding(value) {
    return new Builder({ ...this.value, binding: value });
  }
  source(value) {
    return new Builder({ ...this.value, source: value });
  }
  build() {
    const { name, title, description, dataType, defaultValue, optional, binding, source } = this.value;
    return new OptionParameter(name, title, description, dataType, defaultValue, optional, source, binding);
  }
}
OptionParameter.Builder = Builder;
